import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-about',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutComponent implements OnInit {
  title = 'About us';
  smoothScroll = function(attrName){
    $('html, body').animate({
      scrollTop: $( $('#'+attrName) ).offset().top
    }, 'slow');
    return false;
  };
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/pages/about-us/about-us.component.ts